import React from "react";
import { useTranslation } from "react-i18next";
import { FaChevronRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import { useNavigateWithLang } from "../utils/navigation";

const Breadcrumb = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigateWithLang();
  const params = useParams();

  // Retrieve the array of dynamic path names from Redux
  const breadcrumbDynamicPathNames = useSelector((state) => state.breadcrumbs.breadcrumbDynamicPathNames);
  const breadcrumbDynamicID = useSelector((state) => state.breadcrumbs.breadcrumbDynamicID);

  // Extract the pathnames from the current URL
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Remove the first segment (language) and numeric segments (IDs)
  const breadcrumbPathnames = pathnames.slice(1).filter((path) => isNaN(path));

  // Build breadcrumb items for static paths
  const breadcrumbItems = breadcrumbPathnames.map((path, index) => {
    return {
      label: path?.replace("-", " ").charAt(0).toUpperCase() + path.slice(1),
      link: `/${breadcrumbPathnames.slice(0, index + 1).join("/")}`,
    };
  });

  // Append multiple dynamic path names
  breadcrumbDynamicPathNames?.forEach((name, index) => {
    if (!name) return;

    breadcrumbItems.push({
      label: name.replace("-", " ").charAt(0).toUpperCase() + name.slice(1),
      link:
        index < breadcrumbDynamicPathNames.length - 1
          ? `/${breadcrumbPathnames.slice(0, 2).join("/")}` // Go to the previous path
          : "",
    });
  });

  const handleClick = (label, link) => {
    if (link.includes("students")) {
      if (!label.includes("Students")) {
        localStorage.setItem("selectedTeacherId", breadcrumbDynamicID[0]);
        localStorage.setItem("selectedClassroomId", breadcrumbDynamicID[1]);
      }
    } else if (link.includes("classrooms")) {
      if (!label.includes("Classrooms")) {
        localStorage.setItem("selectedTeacherId", breadcrumbDynamicID[0]);
      }
    }
    navigate(`${link}`);
  };

  return (
    <nav className="container mx-auto flex items-center px-4 py-4 sm:px-8">
      {breadcrumbItems.map((item, index) => (
        <div key={index} className="flex items-center">
          {index > 0 && (
            <FaChevronRight size={"10px"} className="mx-2 text-mutedText dark:text-white rtl:rotate-180" />
          )}

          {index === breadcrumbItems.length - 1 ? (
            <span className="text-sm font-medium leading-[19px] text-blue-500">
              {decodeURIComponent(t(`${item.label}`))
                .split("-")
                .join(" ")}
            </span>
          ) : (
            <button
              onClick={() => handleClick(item.label, item.link)}
              className="text-sm text-mutedText hover:text-blue-500 dark:text-dark-text"
            >
              {t(`${item.label}`)?.split("-")?.join(" ")}
            </button>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumb;
